import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=6afe69fe&scoped=true&"
import script from "./Offers.vue?vue&type=script&lang=js&"
export * from "./Offers.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=6afe69fe&scoped=true&lang=css&"
import style1 from "./Offers.vue?vue&type=style&index=1&id=6afe69fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afe69fe",
  null
  
)

export default component.exports